import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DeleteBin } from "../../assets/Icons";
import Accordion from "../../components/ui/Accordion";
import Modal from "../../components/ui/Modal";
import { deleteRecipient, getRecipientProfile } from "../../services/recipientDetails";

export const RecipientProfile = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [thisRecipient, setThisRecipient] = useState<any>();
  const [isModalOpen, setIsModalOpen] = useState<string>("");

  const getRecepientsDetails = async () => {
    if (state) {
      const userID = state?.userID;
      try {
        const req = await getRecipientProfile(userID);
        const res = req.data;
        if (res) {
          setThisRecipient(res);
        }
      } catch (error) {
        window.console.error(error);
      }
    }
  };

  useEffect(() => {
    getRecepientsDetails();
  }, [state]);

  const handleDeleteRecipient = () => {
    deleteRecipient(thisRecipient?.id)
      .then(() => {
        navigate("/pick-recipient");
      })
      .catch((error: any) => {
        console.error(error);
      });
  };

  return (
    <div className="p-6">
      <div id="banner" className="w-[1460px] relative h-[150px] bg-[#0F5BF1] rounded shadow-xl" />
      <div className="">
        <div
          id="circle"
          className="w-[140px] cursor-pointer h-[140px] border-8 border-white absolute -mt-16 ml-20 flex items-center justify-center rounded-full bg-blue-200 text-[32px] font-bold"
        >
          {thisRecipient?.firstName?.charAt(0) + thisRecipient?.lastName?.charAt(0)}
        </div>
        <div className="ml-[250px] mt-[30px] space-x-10 flex items-center">
          <span className="text-[32px] font-bold">
            {thisRecipient?.firstName + " " + thisRecipient?.lastName}
          </span>
          <span className="text-[32px] font-bold text-gray-500">
            {thisRecipient?.countryOfResidence}
          </span>
          <div id="acnum" className="flex space-x-2">
            <span className="text-[32px] font-bold text-gray-500">A/C No.:</span>
            <span className="text-[32px] font-bold">{thisRecipient?.bankAccountNumber}</span>
          </div>
          <div
            onClick={() => setIsModalOpen("deleteRecipient")}
            className="flex items-center justify-center w-16 h-16 bg-red-500 rounded-full cursor-pointer"
          >
            <DeleteBin />
          </div>
        </div>
      </div>
      <div id="accordions" className="flex flex-col justify-center w-full p-10 mt-8 space-y-4">
        <Accordion
          title={"Recipient Details"}
          titleClassname="font-semibold w-auto text-[16px] lg:text-[18px] py-2"
        >
          <div className="flex flex-col items-center w-full space-y-5 lg:space-y-0 lg:flex-row lg:space-x-20">
            <div id="left" className="w-full space-y-3 lg:px-20 lg:w-1/2">
              {thisRecipient?.firstName && (
                <div className="flex items-center w-full space-x-5">
                  <div>
                    <DeleteBin />
                  </div>
                  <span className="font-bold w-1/2 text-[12px] lg:text-[18px] flex justify-end">
                    Recipient Name:{" "}
                  </span>
                  <span className="font-ssp text-[12px] w-1/2 lg:text-[18px] lg:px-10 lg:py-2 lg:border lg:border-gray-300 rounded">
                    {thisRecipient?.firstName + " " + thisRecipient?.lastName}
                  </span>
                </div>
              )}
            </div>
            <div id="right" className="w-full space-y-3 lg:px-20 lg:w-1/2">
              {thisRecipient?.relationship && (
                <div className="flex items-center w-full space-x-5">
                  <span className="font-bold text-[12px] lg:text-[18px]">Relationship: </span>
                  <span className="font-ssp text-[12px] lg:text-[18px] lg:px-10 lg:py-2 lg:border lg:border-gray-300 rounded">
                    {thisRecipient?.relationship}
                  </span>
                </div>
              )}
            </div>
          </div>
        </Accordion>
        <Accordion
          title={"Address"}
          titleClassname="font-semibold text-[16px] lg:text-[18px] py-2 "
        >
          <div className="flex justify-start w-full space-y-3 flex- lg:space-y-0 lg:flex-row lg:space-x-20">
            <div id="left" className="flex flex-col w-full space-y-3 lg:px-20 lg:w-1/2">
              {thisRecipient?.category && (
                <div className="flex items-center w-full space-x-5">
                  <span className="font-bold text-[12px] lg:text-[18px]">Recipient Category: </span>
                  <span className="font-ssp text-[12px] lg:text-[18px] lg:px-10 lg:py-2 lg:border lg:border-gray-300 rounded">
                    {thisRecipient?.category}
                  </span>
                </div>
              )}
              {thisRecipient?.city && (
                <div className="flex items-center w-full space-x-5">
                  <div className="font-bold text-[12px] flex justify-end lg:text-[18px]">
                    City:{" "}
                  </div>
                  <div
                    style={{ marginLeft: 60 }}
                    className="font-ssp text-[12px] lg:text-[18px] lg:px-10 lg:py-2 lg:border lg:border-gray-300 rounded"
                  >
                    {thisRecipient?.city}
                  </div>
                </div>
              )}
              {thisRecipient?.recipientAddress && (
                <div className="flex items-center w-full space-x-5">
                  <span className="font-bold text-[12px] lg:text-[18px] w-20">
                    Recipient Address:{" "}
                  </span>
                  <span className="font-ssp text-[12px] lg:text-[18px] lg:px-10 lg:py-2 lg:border lg:border-gray-300 rounded">
                    {thisRecipient?.recipientAddress}
                  </span>
                </div>
              )}
            </div>
            <div id="right" className="w-full space-y-3 lg:px-20 lg:w-1/2">
              {thisRecipient?.countryOfResidence && (
                <div className="flex items-center w-full space-x-5">
                  <span style={{ width: 100 }} className="font-bold text-[12px] lg:text-[18px]">
                    Country of Residence:
                  </span>
                  <span className="font-ssp text-[12px] lg:text-[18px] lg:px-10 lg:py-2 lg:border lg:border-gray-300 rounded">
                    {thisRecipient?.countryOfResidence}
                  </span>
                </div>
              )}
              {thisRecipient?.pincode && (
                <div className="flex items-center space-x-5">
                  <span style={{ width: 100 }} className="font-bold text-[12px] lg:text-[18px]">
                    PINCODE:{" "}
                  </span>
                  <span className="font-ssp text-[12px] lg:text-[18px] lg:px-10 lg:py-2 lg:border lg:border-gray-300 rounded">
                    {thisRecipient?.pincode}
                  </span>
                </div>
              )}
            </div>
          </div>
        </Accordion>
        <Accordion
          title={"Bank Details"}
          titleClassname="font-semibold text-[16px] lg:text-[18px] py-2 "
        >
          <div className="flex flex-col items-center w-full space-y-3 lg:space-y-0 lg:flex-row lg:space-x-20">
            <div id="left" className="w-full space-y-3 lg:px-20 lg:w-1/2">
              {thisRecipient?.bankAccountCountry && (
                <div className="flex items-center w-full space-x-5">
                  <span
                    style={{ marginRight: 75 }}
                    className="font-bold text-[12px] lg:text-[18px]"
                  >
                    Bank Country:
                  </span>
                  <span className="font-ssp text-[12px] lg:text-[18px] lg:px-10 lg:py-2 lg:border lg:border-gray-300 rounded">
                    {thisRecipient?.bankAccountCountry}
                  </span>
                </div>
              )}
              {thisRecipient?.bankAccountNumber && (
                <div className="flex items-center w-full space-x-5">
                  <div className="font-bold text-[12px] lg:text-[18px]">Bank Account Number: </div>
                  <div className="font-ssp text-[12px] lg:text-[18px] lg:px-10 lg:py-2 lg:border lg:border-gray-300 rounded">
                    {thisRecipient?.bankAccountNumber}
                  </div>
                </div>
              )}
              {thisRecipient?.ibanCode && (
                <div className="flex items-center w-full space-x-5">
                  <span className="font-bold text-[12px] lg:text-[18px]">IBAN Code: </span>
                  <span className="font-ssp text-[12px] lg:text-[18px] lg:px-10 lg:py-2 lg:border lg:border-gray-300 rounded">
                    {thisRecipient?.ibanCode}
                  </span>
                </div>
              )}
              {thisRecipient?.sortCode ||
                thisRecipient?.bsbCode ||
                (thisRecipient?.transitCode && (
                  <div className="flex items-center w-full space-x-5">
                    <span className="font-bold text-[12px] lg:text-[18px]">
                      Sort/BSB/Transit/Routing:{" "}
                    </span>
                    <span className="font-ssp text-[12px] lg:text-[18px] lg:px-10 lg:py-2 lg:border lg:border-gray-300 rounded">
                      {thisRecipient?.sortCode ||
                        thisRecipient?.bsbCode ||
                        thisRecipient?.transitCode}
                    </span>
                  </div>
                ))}
            </div>

            <div id="right" className="w-full space-y-3 lg:px-20 lg:w-1/2">
              {thisRecipient?.bankName && (
                <div className="flex items-center w-full space-x-5">
                  <span className="font-bold text-[12px] lg:text-[18px]">Bank Name: </span>
                  <span
                    style={{ marginLeft: 30 }}
                    className="font-ssp text-[12px] lg:text-[18px] lg:px-10 lg:py-2 lg:border lg:border-gray-300 rounded"
                  >
                    {thisRecipient?.bankName}
                  </span>
                </div>
              )}
              {thisRecipient?.swiftCode && (
                <div className="flex items-center space-x-5">
                  <span className="font-bold text-[12px] lg:text-[18px]">Swift Code: </span>
                  <span className="font-ssp text-[12px] lg:text-[18px] lg:px-10 lg:py-2 lg:border lg:border-gray-300 rounded">
                    {thisRecipient?.swiftCode}
                  </span>
                </div>
              )}
              {thisRecipient?.unitNumber && (
                <div className="flex items-center space-x-5">
                  <span className="font-bold text-[12px] lg:text-[18px]">Unit Number: </span>
                  <span className="font-ssp text-[12px] lg:text-[18px] lg:px-10 lg:py-2 lg:border lg:border-gray-300 rounded">
                    {thisRecipient?.unitNumber}
                  </span>
                </div>
              )}
              {thisRecipient?.refrence && (
                <div className="flex items-center space-x-5">
                  <span style={{ width: 100 }} className="font-bold text-[12px] lg:text-[18px]">
                    Reference ID/ Field 70:{" "}
                  </span>
                  <span className="font-ssp text-[12px] lg:text-[18px] lg:px-10 lg:py-2 lg:border lg:border-gray-300 rounded">
                    {thisRecipient?.refrence}
                  </span>
                </div>
              )}
            </div>
          </div>
        </Accordion>
      </div>
      <div
        onClick={() => navigate("/pick-recipient")}
        className="flex items-center justify-center px-2 py-3 font-bold text-white bg-primary w-[150px] ml-10 rounded cursor-pointer hover:scale-110 transition-all"
      >
        Go Back
      </div>
      <Modal
        header="Are you sure you want to delete this recipient?"
        headerClass={"bg-white !my-0 py-6 px-12 font-bold text-lg"}
        modalClass="!p-0 !rounded !overflow-hidden !w-full lg:!w-auto mb-40 md:mb-0"
        visible={isModalOpen === "deleteRecipient"}
        closeHandler={() => setIsModalOpen("")}
        closable={false}
      >
        <div className="flex items-center justify-center mb-10 space-x-10">
          <div
            onClick={handleDeleteRecipient}
            className="flex justify-center cursor-pointer px-8 py-2 w-[100px] transition-all font-bold text-white bg-primary hover:bg-primary-100 hover:text-primary hover:border-2 hover:border-primary"
          >
            Yes
          </div>
          <div
            onClick={() => setIsModalOpen("")}
            className="flex justify-center cursor-pointer px-8 py-2 w-[100px] transition-all font-bold text-white bg-primary hover:bg-primary-100 hover:text-primary hover:border-2 hover:border-primary"
          >
            No
          </div>
        </div>
      </Modal>
    </div>
  );
};
